// return the value of a param, or ":specifiedParamName"
export const get = (
	params: { [key: string]: string | number | undefined } | undefined,
	param: string
): string | number | undefined =>
	params && params[param] ? params[param] : ':'.concat(param);

// return the value of a param(including empty string support)
export const getOptional = (
	params: { [key: string]: string | number | undefined } | undefined,
	param: string
): string | number => {
	if (!params || params[param] === null) {
		return `/:${param}?`;
	}
	if (!params[param]) {
		return '';
	}
	return `/${params[param]}`;
};

export const dashboard = (params?: { accessType?: string }): string =>
	`/dashboard${getOptional(params, 'accessType')}`;
export const directory = (params?: { tab?: string }): string =>
	`/directory${getOptional(params, 'tab')}`;
export const campaigns = (): string => `/campaigns`;
export const channels = (params?: {
	page?: string;
	section?: string;
}): string => `/channels${getOptional(params, 'page')}`;
export const flowBuilder = (params?: { route?: string }): string =>
	`/flow-builder${getOptional(params, 'route')}`;
export const numbers = (): string => `/numbers`;
export const chatBot = (params?: { page?: string }): string =>
	`/chatbot/overview${getOptional(params, 'page')}`;
export const ChatbotV2 = (params?: { tab?: string }): string =>
	`/chatbot${getOptional(params, 'tab')}`;
export const CallbacksV2 = (params?: { tab?: string }): string =>
	`/callbacks${getOptional(params, 'tab')}`;
export const conversations = (params?: { tab?: string }): string =>
	`/conversations${getOptional(params, 'tab')}`;
export const urlShortener = (params?: { tab?: string }): string =>
	`/URL-shortener${getOptional(params, 'tab')}`;
export const failover = (params?: { tab?: string }): string =>
	`/failover${getOptional(params, 'tab')}`;

// TODO: Change when using KDS sidebar
export const fallback = (params?: { tab?: string }): string =>
	`/fallback${getOptional(params, 'tab')}`;
export const fallbackV2 = (params?: { page?: string }): string =>
	`/fallback/overview${getOptional(params, 'page')}`;

export const SmsDailyMonthlyLimit = (params?: { path?: string }): string =>
	`/messages/country-limit${getOptional(params, 'path')}`;
export const developers = (): string => '/developers';
export const billing = (): string => '/billing';
export const subAccountsManagement = (params?: { tab?: string }): string =>
	`/subaccounts${getOptional(params, 'tab')}`;
export const addSubAccounts = (): string => '/add-subaccount';
export const editSubAccounts = (): string => '/edit-subaccount';
export const verify = (params?: { tab?: string }): string =>
	`/verify${getOptional(params, 'tab')}`;

// use this for PHP to react
export const v1Directory = (params?: { tab?: string }): string =>
	`/vr/directory${getOptional(params, 'tab')}`;
export const v1CampaignManager = (params?: { tab: string }): string =>
	`/campaigns/voice${getOptional(params, 'tab')}`;
export const v1SMSDashboard = (params?: { tab?: string }): string =>
	`/campaign-insights${getOptional(params, 'tab')}`;
export const v1SipUserGroup = (params?: { tab: string }): string =>
	`/campaigns/voice${getOptional(params, 'tab')}`;
export const v1SipDomain = (params?: { tab: string }): string =>
	`/campaigns/voice${getOptional(params, 'tab')}`;
export const v1SipAcl = (params?: { tab: string }): string =>
	`/campaigns/voice${getOptional(params, 'tab')}`;
export const v1SoundManager = (params?: { tab?: string }): string =>
	`/channels/voice${getOptional(params, 'tab')}`;
export const v1Sip = (params?: { page: string }): string =>
	`/channels/voice/${params?.page}${getOptional(undefined, 'id')}`;
export const v1NumbersManage = (): string => '/numbers/manage';
export const v1SubscribeNumber = (): string => '/numbers/subscribe';
export const v1Signup = (): string => '/vr/signup';
export const v1Login = (): string => '/vr/login';
export const v1Onboard = (params?: { page?: string }): string =>
	`/vr/onboard${getOptional(params, 'page')}`;
export const v1Welcome = (): string => '/vr/welcome';
export const v1AccountSetUp = (params?: { page?: string }): string =>
	'/vr/accountsetup';
export const v1Developers = (params?: { tab?: string }): string =>
	`/developers${getOptional(params, 'tab')}`;
export const v1Billing = (params?: { tab?: string }): string =>
	`/billing${getOptional(params, 'tab')}`;
export const v1flowBuilder = (params?: { tab?: string }): string =>
	`/flow-builder${getOptional(params, 'tab')}`;

export const v1Whatsapp = (params?: { tab?: string }): string =>
	`/vr/channels/whatsapp${getOptional(params, 'tab')}`;
export const v1SMS = (params?: { tab?: string }): string =>
	`/channels/sms${getOptional(params, 'tab')}`;
export const v1Email = (params?: { tab?: string }): string =>
	`/channels/email${getOptional(params, 'tab')}`;

// Integration Directory
export const integrationDirectory = (): string => '/integrations-directory';

export const v1WhatsappActivation = (params?: { tab?: string }): string =>
	`/vr/channels/whatsappActivation${getOptional(params, 'tab')}`;

export const Whatsapp = (): string => `/whatsapp`;

export const v2Whatsapp = (params?: { tab?: string }): string =>
	`/channels/whatsapp${getOptional(params, 'tab')}`;

// Receive Message
export const receiveMessageConfigurations = (): string =>
	'/channels/sms/receive-message/configurations';
export const receiveMessageConfigurationsLogs = (): string =>
	'/channels/sms/receive-message/configurations/logs';
export const receiveMessageLogs = (): string =>
	'/channels/sms/receive-message/logs';
export const receiveMessageNewConfiguration = (): string =>
	'/channels/sms/receive-message/new-configuration';

//whatsapp campaign page
export const v1Campaign = (params?: { tab?: string }): string =>
	`/campaigns/whatsapp${getOptional(params, 'tab')}`;
export const v2WhatsappCampaign = (params?: { page?: string }): string =>
	`/campaigns/whatsapp/detail${getOptional(params, 'page')}`;
export const voiceCampaign = (params?: { tab?: string }): string =>
	`/campaigns/voice${getOptional(params, 'tab')}`;

//Settings KDS
export const v2Settings = (params?: { tab?: string }): string =>
	`/settings${getOptional(params, 'tab')}`;

//Analytics KDS
export const Analytics = (params?: { tab?: string }): string =>
`/analytics${getOptional(params, 'tab')}`;
export const generateReports =(params?: { page?: string }):string =>
`/generate-reports${getOptional(params, 'page')}`

//Analytics-Beta Dashboard
export const AnalyticsBeta = (params?: { tab?: string }): string =>
`/analytics-beta${getOptional(params, 'tab')}`;
export const FallbackDashboard = (params?: { tab?: string }): string =>
`/analytics-beta/dashboard/fallback${getOptional(params, 'tab')}`;

type MenusParams = { path: string; id?: string }[];

const getFullPath = (menusParams?: MenusParams) => {
	let url = '';

	if (!menusParams) {
		return url;
	}

	menusParams.forEach((menuParams, index) => {
		if (!menuParams.path) {
			return;
		}

		url = `${url ? url : '/'}${menuParams.path}`;

		if (menuParams.id) {
			url = `${url}/:${menuParams.id}`;
		}

		if (index < menusParams.length - 1) {
			url = `${url}/`;
		}
	});

	return url;
};

export const videoRoute = '/channels/video';

export const getVideoPath = (menusParams?: MenusParams) => {
	const fullUrl = `${videoRoute}${getFullPath(menusParams)}`;
	return fullUrl;
};
